import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { MembershipProvider } from "@/context/MembershipContext";
import { ProtectedRoute } from "@/components/store/ProtectedRoute";
import StoreLayout from "@/components/store/StoreLayout";
import Home from "@/pages/Home";
import Tienda from "@/pages/Tienda";
import ComoComprar from "@/pages/ComoComprar";
import QuienesSomos from "@/pages/QuienesSomos";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import CloseFriends from "@/pages/CloseFriends";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
          <MembershipProvider>
            <CartProvider>
              <BrowserRouter>
                <Routes>
                  <Route element={<StoreLayout />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/tienda" element={<Tienda />} />
                    <Route path="/como-comprar" element={<ComoComprar />} />
                    <Route path="/nosotros" element={<QuienesSomos />} />
                    <Route path="/contacto" element={<Navigate to="/nosotros#contacto" replace />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:slug" element={<BlogPost />} />
                  </Route>
                  <Route path="/login" element={<AdminLogin />} />
                  <Route path="/close-friends" element={<CloseFriends />} />
                  <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
                </Routes>
              </BrowserRouter>
              <Toaster position="top-center" richColors />
            </CartProvider>
          </MembershipProvider>
        </SettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
